/**
 * IDR Currency Formatting Utility
 * Formats numbers as Indonesian Rupiah (e.g., 5.000 or 5.000,56)
 */
export const formatIDR = (amount: number): string => {
  if (amount === undefined || amount === null) return "0";

  // Use Intl.NumberFormat for robust formatting
  const formatter = new Intl.NumberFormat("id-ID", {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

/**
 * Parse IDR formatted string back to number
 */
export const parseIDR = (idrString: string): number => {
  if (!idrString) return 0;
  // Remove dots (thousands separator) and replace comma with dot (decimal separator)
  const cleanString = idrString
    .toString()
    .replace(/\./g, "")
    .replace(/,/g, ".");
  return parseFloat(cleanString) || 0;
};
